import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  headerRow: {
    border: '1px #D1D1D1 solid'
  }
};

const enhance = compose();

const UserTableHead = enhance(
  ({ order, orderBy, onRequestSort, classes, isFukuoka }) => {
    return (
      <TableHead>
        <TableRow className={classes.headerRow}>
          <TableCell>{isFukuoka ? '画像' : 'メニュー画像'}</TableCell>
          <TableCell sortDirection={orderBy === 'shopId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopId'}
              direction={order}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              {isFukuoka ? '教室ID' : '店舗ID'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'shopName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'shopName'}
              direction={order}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menuId' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuId'}
              direction={order}
              onClick={() => {
                onRequestSort('menuId');
              }}
            >
              {isFukuoka ? 'コースID' : 'メニューID'}
            </TableSortLabel>
          </TableCell>
          <TableCell sortDirection={orderBy === 'menuName' ? order : false}>
            <TableSortLabel
              active={orderBy === 'menuName'}
              direction={order}
              onClick={() => {
                onRequestSort('menuName');
              }}
            >
              {isFukuoka ? 'コース名' : 'メニュー名'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'menuChildType' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'menuChildType'}
              direction={order}
              onClick={() => {
                onRequestSort('menuChildType');
              }}
            >
              {isFukuoka ? 'コース種別' : '種別'}
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'excludedTaxPrice' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'excludedTaxPrice'}
              direction={order}
              onClick={() => {
                onRequestSort('excludedTaxPrice');
              }}
            >
              税抜価格
            </TableSortLabel>
          </TableCell>
          <TableCell
            sortDirection={orderBy === 'includedTaxPrice' ? order : false}
          >
            <TableSortLabel
              active={orderBy === 'includedTaxPrice'}
              direction={order}
              onClick={() => {
                onRequestSort('includedTaxPrice');
              }}
            >
              税込価格
            </TableSortLabel>
          </TableCell>
          <TableCell />
          {!isFukuoka && <TableCell />}
        </TableRow>
      </TableHead>
    );
  }
);

export default withStyles(styles)(UserTableHead);
